
import React, { useEffect } from 'react';
import { app } from "@microsoft/teams-js";
import { AppRoutes, WebRoutes } from '../routes/route.path';
import Config from '../../config';

const MicrosoftOpenPopup = () => {
    useEffect(() => {
        app.initialize().then(() => {
            if (window.location.pathname.includes("microsoft")) {
                const rootUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`;
                //  'https://dev-falkonconnect-fe.azurewebsites.net/channels/microsoft/redirect'
                const options = {
                    redirect_uri: window.location.origin + WebRoutes.CHANNELS_LOGIN_REDIRECT.replace(":login", "microsoft"),
                    client_id: Config.FALKON_CONNECT_LOGIN_MICROSOFT_CLIENT_ID,
                    response_type: 'code',
                    prompt: 'consent',
                    scope: 'User.Read',
                };

                const qs = new URLSearchParams(options).toString();
                const authUrl = `${rootUrl}?${qs}`;
                window.location.assign(authUrl)
            }
            else if (window.location.pathname.includes("google")) {
                const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;
                //  'https://dev-falkonconnect-fe.azurewebsites.net/channels/google/redirect'
                const options = {
                    redirect_uri: window.location.origin + WebRoutes.CHANNELS_LOGIN_REDIRECT.replace(":login", "google"),
                    client_id: Config.FALKON_CONNECT_LOGIN_GOOGLE_CLIENT_ID,
                    access_type: 'offline',
                    response_type: 'code',
                    prompt: 'consent',
                    scope: [
                        'https://www.googleapis.com/auth/userinfo.profile',
                        'https://www.googleapis.com/auth/userinfo.email',
                    ].join(' '),
                };
                const qs = new URLSearchParams(options).toString();
                const authUrl = `${rootUrl}?${qs}`;
                window.location.assign(authUrl);
            }
        })

    }, []);

    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>Redirecting to Azure AD to request permission consent</p>
            </div>
        </div>
    );
};

export default MicrosoftOpenPopup;
